module.exports = __webpack_public_path__ + "static/media/cbdpage.43b161aa.png";